import { useMutation } from "@apollo/client";
import { useUserData } from "@nhost/react";
import React from "react";
import { INSERT_BLOG_POST } from "../../hooks/usePost";

const CreatePost = () => {
  let titleInput, contentInput, categoryInput, authorInput;
  const user = useUserData();
  authorInput = user.displayName;
  const [insert_blog_post, { data, loading, error }] =
    useMutation(INSERT_BLOG_POST);
  if (loading) return alert("submitting");
  if (error) return alert(`${error.message}`);
  if (data) return alert("uploaded");
  return (
    <div className="flex flex-col w-full h-auto justify-between align-middle ">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          insert_blog_post({
            variables: {
              title: titleInput.value,
              content: contentInput.value,
              category: categoryInput.value,
              author_id: authorInput,
            },
          });
          titleInput.value = "";
          contentInput.value = "";
          categoryInput.value = "";
        }}
      >
        <h2 className="text-3xl text-slate-900 text-center font-bold ">
          Create a new post
        </h2>

        <div className=" my-4 ">
          <h2 className=" mx-20 mb-5 font-medium text-teal-800">
            {" "}
            Write Title
          </h2>
          <input
            className="w-1/3 outline-none  mx-20  font-medium  bg-neutral-400 "
            type="text"
            placeholder="Enter your title"
            ref={(i) => (titleInput = i)}
          ></input>
        </div>
        <div>
          <h2 className=" mx-20 mb-5 font-medium text-teal-800">
            {" "}
            Select Category
          </h2>
          <select className="mx-20 text-medium text-teal-800 " ref={(i) => (categoryInput = i)}>
            <option value="developemnet">Developement</option>
            <option value="Car">Car</option>
            <option value="Cinema">Cinema</option>
            <option value="News">News</option>
            <option value="Bike">Bike</option>
            <option value="Health">Health</option>
            <option value="Animal">Animal</option>
            <option value="TECHnology">Technology</option>
           
          </select>
        </div>
        <div>
          <h2 className=" mx-20 my-5 font-medium text-teal-800">
            {" "}
            Write Content
          </h2>
          <textarea
            className="w-5/6 h-screen rounded-lg outline-none my-4  mx-20  font-medium  bg-neutral-400  "
            placeholder="Write your post here..."
            ref={(i) => (contentInput = i)}
          ></textarea>
        </div>

        <button className="ml-20  relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900  w-24 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 ">
          Submit
        </button>
      </form>
    </div>
  );
};

export default CreatePost;
